module.exports = __webpack_public_path__ + "static/media/laugh.1b44ae30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laugh.png
// module id = 123
// module chunks = 0